import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/internal/operators/catchError';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class ViolationService {

  constructor(private http: HttpClient) { }

  getViolationData() {
    return this.http.get<any>(urls.BASE_URL + urls.GET_CAUTIONS_URL).pipe(
      catchError(errorHandl)
    );
  }

  saveViolation(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.GET_CAUTIONS_URL, payload).pipe(
      catchError(errorHandl)
    );
  }

}
